import React from 'react'

import styles from './words-left.module.scss'

interface WordsLeftProps {
  wordCount: number
  minWordCount?: number
}

export const WordsLeft: React.FC<WordsLeftProps> = ({ wordCount, minWordCount = 0 }) => {
  const wordsLeft = minWordCount - wordCount

  return (
    <div className={styles.wordsLeft}>
      {wordCount && wordsLeft > 0 ? (
        <span>
          Enter <b>{wordsLeft}</b> more {wordsLeft > 1 ? 'words' : 'word'}
        </span>
      ) : null}
    </div>
  )
}
